import MUIModal from "../../../shared/MUIModal";
import SABox from "../../../shared/SABox";
import SAButton from "../../../shared/SAButton";
import SATypography from "../../../shared/SATypography";

const DeliverToShowroomModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  t,
  deliveryStatus,
}) => {
  // deliveryStatus: "OUT_FOR_DELIVERY" or "DELIVER_TO_SHOWROOM"
  const getText = () => {
    if (deliveryStatus === "OUT_FOR_DELIVERY") {
      return t("deliver-to-showroom-confirmation");
    }
    return t("delivery-status-confirmation");
  };

  return (
    <MUIModal
      open={open}
      maxWidth="xs"
      handleClose={onClose}
      content={
        <SABox p={3}>
          <SATypography mb={2} fontWeight={600} fontSize={18} align="center">
            {getText()}
          </SATypography>
          <SABox display="flex" gap={2} justifyContent="center">
            <SAButton onClick={onClose} color="primary" disabled={loading}>
              {t ? t("cancel") : "Cancel"}
            </SAButton>
            <SAButton
              variant="contained"
              color="primary"
              onClick={onConfirm}
              loading={loading ? 1 : 0}
            >
              {t ? t("confirm") : "Confirm"}
            </SAButton>
          </SABox>
        </SABox>
      }
    />
  );
};

export default DeliverToShowroomModal;
